import { IdentityAnswers } from "merchant-api/types";

export function toIdentityAnswers(values, idNumber): IdentityAnswers {
  const answers: any = Object.entries(values).map(([key, value]) => ({
    type: key.replace(/\_/g, '.'),
    answer: value,
  }));

  return {
    idNumber,
    answers,
  };
}

export const getNextStepAfterIdentity = ({
  stepOrder,
  checkoutData,
}: {
  stepOrder: string[];
  checkoutData?: {
    isFincenAdditionalOwnersPassed?: boolean;
    isFincenControlPersonPassed?: boolean;
    selectedDrawAmount?: number | null;
  };
}) => {
  const fincenDone = !!checkoutData?.isFincenAdditionalOwnersPassed && !!checkoutData?.isFincenControlPersonPassed;

  const identityIndex = stepOrder.indexOf('IDENTITY');

  if (identityIndex === -1) {
    return 'TERMS_AND_AGREEMENTS';
  }

  const remainingSteps = stepOrder.slice(identityIndex + 1);

  const nextStep = remainingSteps.find((step) => {
    if (step === 'REQUIRED_FIRST_DRAW') {
      return !checkoutData?.selectedDrawAmount;
    }

    if (step === 'FINCEN') {
      return !fincenDone;
    }

    return step === 'TERMS_AND_AGREEMENTS';
  });

  return nextStep ?? 'TERMS_AND_AGREEMENTS';
};
